// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1gj20","fileBtn":"File_fileBtn__Tu-X-","closeBtn":"File_closeBtn__2MdsA","fileSelected":"File_fileSelected__1BhH7","disabled":"File_disabled__3UQv9"};